/**
 * Class description
 *
 * Created: 2019-08-13
 * @author jonas
 */

import {Ease, Linear, TimelineLite, TweenLite} from "gsap";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {HarlequinGameConfig} from "../../HarlequinGameConfig";
import {BasicBitmapCountUp} from "../../display/BasicBitmapCountUp";
import {HarlequinTextStyles} from "../../config/HarlequinTextStyles";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {HarlequinSoundConfig} from "../../HarlequinSoundConfig";

export class CountUpView extends BaseView {
    private _layer:ScalableLayer;
    private _bitmapText:BasicBitmapCountUp;
    private _soundPlaying:boolean = false;
    private _playCountEnds:boolean = false;
    private _endValue:number = 0;

    private _tmpCntr:number = 0;
    private _aborted:boolean = false;
    private _currentOrientation:Orientation;
    private _cuEndPlayed:boolean = false;

    constructor() {
        super();
        this._layer = StageManager.getLayer(HarlequinGameConfig.instance.LAYERS.WIN_COUNT_UP.name);
    }


    protected initAnimations():void {
        this._bitmapText = new BasicBitmapCountUp(HarlequinTextStyles.WIN_COUNT_UP, 450, new PIXI.Point(0.5, 0.5));
        //this._bitmapText.position.set(GameConfig.instance.REEL_AREA_WIDTH * 0.5 + GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_HEIGHT * 0.5 + GameConfig.instance.REEL_AREA_POS_Y);

        //this._bitmapText.position.set(630, 450);

        this.addChild(this._bitmapText);
    }

    onResize(data:IResizeData) {
        this._currentOrientation = data.orientation;

        if(data.orientation === Orientation.PORTRAIT) {
            this._bitmapText.position.set(360, 390);

            if(Math.abs(this._endValue) > 100000000) {
                this._bitmapText.scale.set(0.5, 0.5);
            }
        }
        else {
            this._bitmapText.position.set(365, 400);

            if(Math.abs(this._endValue) > 1000000) {
                this._bitmapText.scale.set(0.7, 0.7);
            }
        }

    }

    public calculateTextScale(from:number, to:number){
        this._bitmapText.preCalculateScale(from, to);
    }

    public getWinStepAnimation(from:number, to:number, duration:number, ease:Ease = Linear.easeNone, winRatio:number = 0, aborted:boolean = false):TimelineLite {
        //this._bitmapText.preCalculateScale(from, to);
        this._playCountEnds = false;
        const ratio:number = winRatio;
        const tl:TimelineLite = new TimelineLite();
        this._aborted = false;

        this._endValue = to;

        tl.add(() => {
            this._layer.addChild(this);

            if(this._currentOrientation === Orientation.PORTRAIT) {
                if(Math.abs(this._endValue) > 99999) {
                    this._bitmapText.scale.set(0.5, 0.5);
                }
            }
            else {
                if(Math.abs(this._endValue) > 9999999) {
                    this._bitmapText.scale.set(0.7, 0.7);
                }
            }

            if(ratio >= 3) {
                if(!aborted) {
                    this.startCountUpSound();
                }
                this._playCountEnds = true;
            }
            else {
                this._playCountEnds = true;
            }

            if(ratio >= 15){
                this._playCountEnds = false;
            }

        });
        tl.add(this._bitmapText.getCountAnimation(from, to, duration, ease));
        //tl.add(() => {},  "+=0.5");

        return tl;
    }

    public abort(value:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => this._bitmapText.stopAt(value));
        return tl;
    }


    public end(value:number, displayDuration:number, fadeDuration:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            this.stopCountUpSound();
            this._aborted = true;
            this._bitmapText.stopAt(value);
            SlotGame.winFieldController.showWinField();
            this._cuEndPlayed = false;
        });
        tl.add(() => this.fadeAndRemove(fadeDuration), displayDuration);
        return tl;
    }


    public fadeAndRemove(fadeDuration:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(new TweenLite(this, fadeDuration, {alpha : 0, ease : Linear.easeNone}));
        tl.add(() => {
            this._layer.removeChild(this);
            this.alpha = 1;
        });
        return tl;
    }


    private startCountUpSound() {
        //if(!this._soundPlaying) {
            this._soundPlaying = true;
            //this._cuEndPlayed = false;

            SlotGame.sound.playEffect(HarlequinSoundConfig.instance.COUNTUP);
        //}
    }

    private stopCountUpSound() {
        if(this._soundPlaying) {
            this._soundPlaying = false;

            SlotGame.sound.stopEffect(HarlequinSoundConfig.instance.COUNTUP);
        }

        if(this._playCountEnds && !this._cuEndPlayed) {
            this._cuEndPlayed = true;
            // #323
            !HarlequinGameConfig.instance.WIN_BELOW_STAKE && SlotGame.sound.playEffect(HarlequinSoundConfig.instance.COUNTUP_ENDS);
        }
    }
}